import { useSSRContext } from 'vue';
import { type SSRContext } from './types';

export function getSSRContext(): SSRContext {
  if (import.meta.env.SSR) {
    return useSSRContext<SSRContext>() || ({} as SSRContext);
  }
  return {} as SSRContext;
}
